import React from 'react';
import { IConnectedPage } from '../../../types/api/connectedPages/IConnectedPage';

type IndexTree = { pages: IConnectedPage[] };

export function IndexTree({ pages }: IndexTree) {
  if (!pages || pages.length === 0) {
    return null;
  }

  return (
    <ul className="eoc__index-tree-list">
      {pages.map(page => (
        <li key={page.pageId + page.title} className="eoc__index-tree-list-item">
          <div className="eoc__index-tree-content">
            <a className="eoc__index-tree-link font-bold-15-19" href={`#${page.pageId}`}>
              {page.title}
            </a>
            {page.description && <p className="eoc__index-tree-description font-regular-15-19">{page.description}</p>}
          </div>
          {page.childPages && page.childPages.length > 0 && <IndexTree pages={page.childPages} />}
        </li>
      ))}
    </ul>
  );
}
